const productCodes = Object.freeze({
  INSIGHT: 'insight',
  METAXPLORE: 'metaxplore',
  METAXPLORE_GI: 'metaxplore-gi',
  METAXPLORE_GI_PLUS: 'metaxplore-gi-plus',
  MICROBIOME_EXPLORER_GI_ASSESSMENT: 'microbiome-explorer-gi-assessment'
})

// these are NOT display names, it's the product.name column in core - this is more like a human-readable primary key
// do not change. If you want to show a different name in the UI, look it up using productCode or productName + translations
export const products = ['MetaXplore', 'MetaXplore GI Plus', 'MetaXplore GI', 'Microbiome Explorer GI Assessment']

export const productsRequiringWorkflowRemoval = [
  productCodes.METAXPLORE,
  productCodes.METAXPLORE_GI,
  productCodes.METAXPLORE_GI_PLUS,
  productCodes.MICROBIOME_EXPLORER_GI_ASSESSMENT
]

export const isMicrobiomeExplorerRange = (code) =>
  [
    productCodes.METAXPLORE,
    productCodes.METAXPLORE_GI,
    productCodes.METAXPLORE_GI_PLUS,
    productCodes.MICROBIOME_EXPLORER_GI_ASSESSMENT
  ].includes(code)

export const productBrandMap = {
  metaxplore: 'Microbiome Explorer - Essentials',
  'metaxplore-gi': 'Microbiome Explorer - Extended',
  'metaxplore-gi-plus': 'Microbiome Explorer - Comprehensive',
  'microbiome-explorer-gi-assessment': 'GI Navigator'
}

export default productCodes
